// components/sections/FooterSection.jsx
import React from 'react';
import { footerLinks } from '../../config/footerLinks';
import { Link } from 'react-router-dom';
import Container from '../ui/Container'
import FooterBanner from '../../assets/images/footer-banner.webp'
import Typography from '../ui/Typography';
import FooterCover from '../../assets/images/footer-card-cover.webp'
import FooterLogo from '../../assets/images/logo/logo-new.svg';
import RegularBtn from '../common/RegularBtn';
import PopButton from '../common/PopButton';
import { useLocation } from 'react-router-dom';
// import LinkedIn from '../../assets/images/Icons/linkedin.webp'
// import Twitter from '../../assets/images/Icons/twitter.webp'
// import YouTube from '../../assets/images/Icons/youtube.webp'
// import Instagram from '../../assets/images/Icons/instagram.webp'
// import Icons from '../ui/Icons.tsx'

const FooterSection = () => {
  const location = useLocation();
  return (
    <footer className="w-full text-white md:pt-[4.5rem] md:pb-11 relative overflow-hidden bg-black">
      {/* Main Engage Card - Mobile: Full width, Desktop: Left */}
      <Container className="bg-cover md:rounded-[21.08px] md:py-[1.6rem] py-[3rem] px-[1.25rem]" style={{ backgroundImage: `url(${FooterBanner})` }}>
        <div className="p-8 lg:px-8 py-[2.85rem] shadow-2xl bg-cover rounded-[17.56px] flex md:flex-row flex-col items-center" style={{ backgroundImage: `url(${FooterCover})` }}>
          <div className="flex-1">
            <Typography as="div" variant='bold' size="h3" className="text-[#FFFFFF] pb-4">
              Engage Securely
            </Typography>
            <Typography as="div" variant="" size="sm" className="text-[#FFFFFF] leading-[22.8px] font-regular tracking-[-0.03em]">
              All inquiries are handled with strict confidentiality. Engagement begins<br /> with a secure consultation.
            </Typography>
          </div>
          <div className="flex-none md:w-[30.5%] w-full flex gap-2 md:pt-0 pt-10">
            <PopButton className="flex-1 !font-medium bg-gradient-to-b from-[#2BFFFF] to-[#1CA3A3]">
              Request Consultation
            </PopButton>

            {location.pathname !== "/solutions" && (
              <RegularBtn
                to="/solutions"
                className="flex-1 
                text-white
                border border-white/10
                bg-white/5
                backdrop-blur-md
                shadow-[inset_0_0_2px_1px_rgba(255,255,255,0.25)]"
              >
                Explore Solutions
              </RegularBtn>
            )}
          </div>
        </div>

        {/* Footer Content Grid - Mobile: Stacked, Desktop: 3-column */}
        <div className="grid grid-cols-1 lg:grid-cols-[490px_240px_1fr] items-start pt-10">
          {/* Logo & Social */}
          <div className="flex flex-col gap-6 items-center lg:items-start text-center lg:text-left mt-4">
            <div>
              <Link to="/">
                <img src={FooterLogo} alt="" width="" height="" className="" />
              </Link>
            </div>
            {/* <div className="flex gap-2 pt-4">
              <Icons href="#" target="_blank" rel="noopener noreferrer" src={Instagram} width={34} height={34} imgClassName="" />
              <Icons href="#" target="_blank" rel="noopener noreferrer" src={Twitter} width={34} height={34} imgClassName="" />
              <Icons href="#" target="_blank" rel="noopener noreferrer" src={LinkedIn} width={34} height={34} imgClassName="" />
              <Icons href="#" target="_blank" rel="noopener noreferrer" src={YouTube} width={34} height={34} imgClassName="" />
            </div> */}
          </div>

          {/* Company Links */}
          <div className="flex flex-col items-center lg:items-start text-center lg:text-left md:mt-0 mt-[4rem]">
            <Typography as="div" size="base" variant="bold" className="text-white pb-5">
              Company
            </Typography>
            <ul className="space-y-3 text-slate-300">
              {footerLinks.company.map((link, idx) => {
                const isPdf = link.href.toLowerCase().endsWith('.pdf');

                return (
                  <li key={idx}>
                    {isPdf ? (
                      <a
                        href={link.href}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <Typography
                          as="div"
                          size="sm"
                          variant="regular"
                          className="text-[#FFFFFFCC]"
                        >
                          {link.label}
                        </Typography>
                      </a>
                    ) : (
                      <Link to={link.href}>
                        <Typography
                          as="div"
                          size="sm"
                          variant="regular"
                          className="text-[#FFFFFFCC]"
                        >
                          {link.label}
                        </Typography>
                      </Link>
                    )}
                  </li>
                );
              })}
            </ul>
          </div>

          {/* Solutions Links */}
          <div className="flex flex-col items-center lg:items-start text-center lg:text-left md:mt-0 mt-[4rem]">
            <Typography as="div" size="base" variant="bold" className="text-white pb-5">
              Solutions
            </Typography>
            <ul className="space-y-3 text-slate-300">
              {footerLinks.solutions.map((link, idx) => (
                <li key={idx}>
                  <Link to={link.href}>
                    <Typography as="div" size="sm" variant="regular" className="text-[#FFFFFFCC]">{link.label}</Typography>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="w-full mt-10 pt-10 border-t border-white/10 text-center text-xs text-slate-500 flex md:flex-row flex-col justify-between items-center">
          <Typography as="div" size="ms" className="font-regular leading-[15.8px] tracking-[-0.03em] text-[#FFFFFFE5]">&copy;2026 SHG Ventures. All rights reserved</Typography>
          <Typography as="div" size="ms" className="inline-flex items-center gap-1 font-regular leading-[15.8px] tracking-[-0.03em] text-[#FFFFFFE5]">
            Made with love
            <svg width="13" height="11" viewBox="0 0 13 11" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 3.6406C0 6.66582 2.5008 8.27765 4.33098 9.7209C4.97671 10.2298 5.5988 10.7094 6.22089 10.7094C6.84298 10.7094 7.46507 10.2304 8.11079 9.72028C9.9416 8.27828 12.4418 6.66582 12.4418 3.64123C12.4418 0.61663 9.02029 -1.5302 6.22089 1.37869C3.42149 -1.5302 0 0.615386 0 3.6406Z" fill="#00C71C" />
            </svg>
            by <a href='https://www.kytzlabs.com/?utm_source=Client-website&utm_medium=SHG_Ventures&utm_campaign=Footer-link' target="_blank" rel="noopener noreferrer" className="font-semibold">Kytz Labs</a></Typography>
        </div>
      </Container>
    </footer>
  );
};

export default FooterSection;